import React, {useEffect, useState} from "react";
import { GridThemeProvider } from "styled-bootstrap-grid";
import GlobalStyles from "../../styles/GlobalStyles.js";
import "../../../node_modules/normalize.css/normalize.css";
import Icons from "../Core/Icons.js";
import SEO from "../SEO.js";
import Bar from "./Bar";
import Nav from "./Nav.js";
import Footer from "./Footer.js";
import SignUp from "../SignUp.js";
import getCookie from "../../functions/getCookie.js";
import { Helmet } from "react-helmet"

const gridTheme = {
    row: {
        padding: 0,
    },
    col: {
        padding: 0
    },
};

export default function Layout({ children, data, url }) {
    const [isSearchForm, setSearchForm] = useState(false);
    const [isProperty, setProperty] = useState(false);
    const [isActive, setActive] = useState(true);
    const {settings} = data;
    const regions = data.regions.nodes;
    const prop = data.property;
    let searchForm = null;
    let pb;

    // set tracking_profile_id 
    const makeid = (length) => {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    let tracking_profile_id = "";
    // check tracking_profile_id in cookie 
    if (typeof window !== "undefined") {
      tracking_profile_id = getCookie("tracking_profile_id") ? getCookie("tracking_profile_id") : window.localStorage.getItem("tracking_profile_id");
      if (!tracking_profile_id) {
        tracking_profile_id = new Date().getTime() + makeid(5);
      }

      document.cookie = `tracking_profile_id=${tracking_profile_id}; path=/; max-age=31536000`;
      window.localStorage.setItem("tracking_profile_id", tracking_profile_id)
    }

    useEffect(() => {
        searchForm = document.getElementById("search-form");

        if (searchForm !== null && isSearchForm === false) {
            setSearchForm(true);
        } else if (searchForm === null && isSearchForm === true) {
            setSearchForm(false);
        }

        if (prop !== undefined && isProperty === false) {
            setProperty(true);
        } else if (prop === undefined && isProperty === true) {
            setProperty(false);
        }

        // get / set initial entered page in session storage for use in utm params
        if (typeof window !== "undefined") {
          !window.sessionStorage.getItem("landingUrl") ? window.sessionStorage.setItem("landingUrl", url) : null; 
        }

        // check if user has seen the email signup modal before
        if (typeof window !== "undefined"){
            if (localStorage.getItem("popUpSeen") === "true") {
                setActive(false);
            }
        }

        // set TD here once mounted
        setTimeout(() => {
            window.td = window.Treasure ? new window.Treasure({
               host: 'in.treasuredata.com',
               writeKey: '6494/0c677229366728ed4ae683e9a71cd66df7161506',
               database: "snaptrip_events_production"
            }) : null;

        }, 10);

        setTimeout(() => {

            // Only track if window.td exists and we have tracking_profile_id
            if (typeof window !== "undefined" && window.td) {
                const trackingId = getCookie("tracking_profile_id") || window?.localStorage.getItem("tracking_profile_id");

                if (trackingId) {
                    window.td.trackEvent('affiliate_pageviews', {
                        td_url: window.location.href,
                        td_title: document.title,
                        td_referrer: document.referrer,
                        td_path: window.location.pathname,
                        td_user_agent: navigator.userAgent,
                        tracking_profile_id: trackingId,
                    });

                    window.td.set('$global', 'td_global_id', 'td_global_id');
                }
            }
        }, 350);
    }, [url]);

    const hidePopup = () => {
        setActive(false);
        localStorage.setItem("popUpSeen", "true");
    };

    const SEOOverrides = {};
    SEOOverrides.robots = "all";
    
    if (typeof window !== "undefined") {
      if (isProperty) {
        window.pageType =  "property";
      } else {
        window.pageType =  "";
      }
    }

    // SEO overrides 
    switch(true) {
        case data.region !== undefined:
            data.region.titleSEO ? SEOOverrides.title = data.region.titleSEO : null;
            data.region.descriptionSEO ? SEOOverrides.description = data.region.descriptionSEO : null;
            data.region.keywordsSEO ? data.region.keywordsSEO.length > 0 ? SEOOverrides.keywords = data.region.keywordsSEO : null : null;
            data.region.noindex ? SEOOverrides.robots = "noindex" : SEOOverrides.robots = "all";
            pb = data.region.pageBuilder || [];
            break;
        case data.ppc !== undefined:
            data.ppc.titleSEO ? SEOOverrides.title = data.ppc.titleSEO : null;
            data.ppc.descriptionSEO ? SEOOverrides.description = data.ppc.descriptionSEO : null;
            data.ppc.keywordsSEO ? data.ppc.keywordsSEO.length > 0 ? SEOOverrides.keywords = data.ppc.keywordsSEO : null : null;
            SEOOverrides.robots = "noindex";
            pb = data.ppc.pageBuilder || [];
            break;
        case data.property !== undefined:
            data.property.titleSEO ? SEOOverrides.title = data.property.titleSEO : null;
            data.property.descriptionSEO ? SEOOverrides.description = data.property.descriptionSEO : null;
            data.property.keywordsSEO ? data.property.keywordsSEO.length > 0 ? SEOOverrides.keywords = data.property.keywordsSEO : null : null;
            data.property.noindex ? SEOOverrides.robots = "noindex" : SEOOverrides.robots = "all";
            pb = data.property.pageBuilder || [];
            break;
        case data.blog !== undefined:
            data.blog.titleSEO ? SEOOverrides.title = data.blog.titleSEO : null;
            data.blog.descriptionSEO ? SEOOverrides.description = data.blog.descriptionSEO : null;
            data.blog.keywordsSEO ? data.blog.keywordsSEO.length > 0 ? SEOOverrides.keywords = data.blog.keywordsSEO : null : null;
            data.blog.noindex ? SEOOverrides.robots = "noindex" : SEOOverrides.robots = "all";
            pb = data.blog.pageBuilder || [];
            break;
        case data.home !== undefined:
            pb = data.home.pageBuilder || [];
            break;
        case url === "/contact/":
            SEOOverrides.title = "Contact us - Hot Tub Hideaways - Find Your Hot Tub Escape";
            break;
    }

    (pb || []).map((c, i) => {
        switch (c._type) {
            case "trustpilot":
                SEOOverrides.trustPilot = true;
                break;
        }
    });

    return (
      <>
        <Helmet>
          <script type="text/javascript">
            {`!function(t,e){if(void 0===e[t]){e[t]=function(){e[t].clients.push(this),this._init=[Array.prototype.slice.call(arguments)]},e[t].clients=[];for(var r=function(t){return function(){return this["_"+t]=this["_"+t]||[],this["_"+t].push(Array.prototype.slice.call(arguments)),this}},s=["blockEvents","unblockEvents","setSignedMode","setAnonymousMode","resetUUID","addRecord","fetchGlobalID","set","trackEvent","trackPageview","trackClicks","ready"],n=0;n<s.length;n++){var c=s[n];e[t].prototype[c]=r(c)}var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=("https:"===document.location.protocol?"https:":"http:")+"//cdn.treasuredata.com/sdk/2.1/td.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)}}("Treasure",this);`}
          </script>
        </Helmet>
        <Icons />
        <SEO {...settings} {...SEOOverrides} path={url} />
        <GridThemeProvider gridTheme={gridTheme}>
          <GlobalStyles {...settings} />
          <Bar />
          <Nav regions={regions} settings={settings} isSearchForm={isSearchForm} isProperty={isProperty} />
          {isActive && (
                <SignUp hidePopup={hidePopup} settings={settings}/>
            )}
          { children }
          <Footer {...settings} property={!!data.property} />
        </GridThemeProvider>
      </>
    );
}